import React from 'react'
import { getToolUrl } from '@services/ToolMenuConfigService'
import { IOperationsTabConfig } from '../../types'
import OrdersView, { ORDERS_ASSET_ID, ORDERS_DISPLAY_NAME } from './OrdersView'

/**
 * The Orders tab: the Orders page embedded as the panel. No metric line yet.
 *
 * Shown only where the Orders tool resolves to a URL for this domain and platform (it is
 * registered for beta and gamma, not prod), so prod users never see a tab that opens a blank panel.
 */
export const ordersTab: IOperationsTabConfig = {
    id: 'orders',
    labelStringId: 'jsma-web-operations-ordersTabLabel',
    renderContent: () => <OrdersView />,
    // Keep the content mounted across tab switches so the iframe, and the user's filters, survive.
    keepMounted: true,
    isAvailable: () => !!getToolUrl(ORDERS_DISPLAY_NAME, ORDERS_ASSET_ID),
}
